import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import InvoicingStep from './InvoicingStep';
import api from '../utils/ApiManager';
import Navbar from '../components/Navbar';
import ProcessSteps from '../components/ProcessSteps';

const InvoiceForm = () => {
  const { t } = useTranslation('invoiceForm');
  const { bucketId } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleComplete = async (invoiceData) => {
    try {
      setIsLoading(true);
      setError(null);
      const sessionResponse = await api.post('/api/payment/create-checkout-session', {
        bucketId,
        invoiceData
      });

      if (sessionResponse?.data?.url) {
        window.location.href = sessionResponse.data.url;
      } else {
        throw new Error(t('errors.missingBucket'));
      }
    } catch (error) {
      console.error('Error creating payment session:', error);
      setError(error.response?.data?.error || t('errors.general'));
      if (error.response?.status === 404) {
        navigate('/upload');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="container mx-auto p-4 mt-16">
        <ProcessSteps currentStep={2} />
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4" role="alert">
            <span className="block sm:inline">{error}</span>
          </div>
        )}
        <InvoicingStep 
          bucketId={bucketId} 
          onComplete={handleComplete}
          disabled={isLoading}
        />
      </div>
    </div>
  );
};

export default InvoiceForm;